module.exports = __webpack_public_path__ + "img/poe.9a122ab6.svg";